module.exports = __webpack_public_path__ + "img/platform_md.5dc200a1.png";